<template>
    <div id="WaitingRoom">
        <div class="d-flex flex-column justify-content-center align-items-center py-5 my-3">
            <h1 v-if="time_left>0" class="waiting-room-title brand-secondary">You're Early!</h1>
            <div class="waiting-room-meta d-flex flex-row flex-nowrap">
                <span>Service Provider: {{ coach.name }}</span>
                <span class="mx-4">|</span>
                <span><i class="fas fa-clock brand-secondary" aria-hidden="true"></i>
                    {{ getHoursMinutes(booking.start) }} -
                    {{ getHoursMinutes(booking.end) }}
                </span>
            </div>
            <div class="waiting-room-video-container d-flex flex-column justify-content-center align-items-center">
                <div class="waiting-room-video d-flex justify-content-center align-items-center">
                    <div class="waiting-room-countdown">
                        <div v-if="time_left>0" class="waiting-room-counter">
                            Session Starting In<br />
                          <span class="waiting-room-timer" v-if="days">{{ days }} {{days > 1 ? 'days' : 'day'}}</span>
                            <span class="waiting-room-timer"
                                v-else-if="hours !== ''">{{ hours }}:{{ minutes }}:{{ seconds }}</span>
                        </div>
                        <div v-else>
                          <p class="animated pulse start-soon">Appointment will start soon, please wait</p>
                        </div>
                        <Loader />
                    </div>
                </div>
            </div>
            <p class="waiting-room-p">
                Wait here for your session to start or alternatively check back close to when your session is due to
                start.
            </p>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import Loader from "@/components/Loader";

export default {
    components: {
        Loader
    },
    props: ['booking', 'coach'],
    name: "WaitingRoom",
    data() {
        return {
            isEarly: true,
            timeRemaining: '',
            intervalFunction: '',
            seconds: '',
            minutes: '',
            hours: '',
            days: '',
            time_left: null
        };
    },
    mounted() {
        try{
          let self = this;
          this.intervalFunction = setInterval(function () {
            const timeLeft = moment(moment(self.booking.start).diff(moment(), "milliseconds")); // get difference between now and timestamp
            self.days = moment.duration(timeLeft).days();
            if(moment.duration(timeLeft).days()) {
              const apptTime = moment(self.booking.start);
              const now = moment();
              if(apptTime.hour() > now.hour() || (apptTime.hour() === now.hour() && apptTime.minute() >= now.minute())) {
                self.days = moment.duration(timeLeft).days()
              } else {
                self.days = moment.duration(timeLeft).days() + 1
              }
            }
            self.seconds = moment.duration(timeLeft).seconds();
            self.minutes = moment.duration(timeLeft).minutes();
            self.hours = Math.trunc(moment.duration(timeLeft).asHours());
            if (self.seconds < 10) self.seconds = '0' + self.seconds
            if (self.minutes < 10) self.minutes = '0' + self.minutes
            self.time_left = timeLeft
            if (timeLeft < 1500) {
              clearInterval(self.intervalFunction);
              self.updateParentTimeout();
            }
          }, 1000);
        }catch (e){
          console.warn(e)
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalFunction);
    },
    methods: {
        updateParentTimeout() {
            this.$root.$emit('timeoutOver')
        },
    }

};
</script>
<style lang="less">
#WaitingRoom {
    .waiting-room-title {
        font-weight: bold;
        padding-bottom: 1.5rem;
        color: white!important;
    }

    .waiting-room-meta {
        font-size: 1.6rem;
        padding-bottom: 1.5rem;
        color: white;
    }

    .waiting-room-video-container {
        max-width: 600px;
        width: 100%;
        aspect-ratio: 16/9;
        position: relative;
        margin-bottom: 1.5rem;
        display: flex;

        .waiting-room-video {
            background: rgb(15,15,15);
            background: linear-gradient(225deg, rgba(15,15,15,1) 0%, rgba(97,97,97,1) 73%, rgba(28,28,28,1) 100%);
            width: 100%;
            flex-grow: 1;
        }
    }

    .waiting-room-counter {
        text-align: center;
        color: white;
        font-size: 1.8rem;

        .waiting-room-timer {
            font-size: 3.6rem;
            font-weight: bold;
        }
    }

    .waiting-room-p {
        max-width: 600px;
        text-align: center;
        font-size: 1.6rem;
        padding-bottom: 1.5rem;
        color: white!important;
    }
    .pulse {
      -webkit-animation-name: pulse;
      animation-name: pulse;
    }
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  .start-soon{
    font-size:2rem;
    color:#fff!important;
  }
  height: 100%;
}
</style>